import get from 'lodash.get'

export const createGroupHeaderAccessor = (pivotValueAccessor, parentGrouping, getSubRows, parentValue, parentDisplayName) => {
  return (row) => {
    const rowId = row.orionEntityId || row.levelName
    const rowName = row.levelName

    if (row.grouping === parentGrouping && (rowId === parentValue || rowName === parentDisplayName)) {
      return get(row, pivotValueAccessor)
    }

    if (row.__originalData) {
      const origId = row.__originalData.orionEntityId || row.__originalData.levelName
      const origName = row.__originalData.levelName

      if (row.__originalData.grouping === parentGrouping && (origId === parentValue || origName === parentDisplayName)) {
        return get(row.__originalData, pivotValueAccessor)
      }
    }

    if (row.__parentChain && Array.isArray(row.__parentChain)) {
      for (const parent of row.__parentChain) {
        const parentId = parent.orionEntityId || parent.levelName
        const parentName = parent.levelName

        if (parent.grouping === parentGrouping && (parentId === parentValue || parentName === parentDisplayName)) {
          return get(row, pivotValueAccessor)
        }
      }
    }

    const dataToSearch = row.__originalData || row
    const subRows = getSubRows(dataToSearch)

    if (subRows && subRows.length > 0) {
      const sumMatchingDescendants = (rows) => {
        let sum = 0
        if (!Array.isArray(rows)) return sum

        rows.forEach(child => {
          if (child.grouping === parentGrouping) {
            const childId = child.orionEntityId || child.levelName
            const childName = child.levelName

            if (childId === parentValue || childName === parentDisplayName) {
              const value = get(child, pivotValueAccessor)
              sum += Number(value) || 0
            }
          }

          const childSubRows = getSubRows(child)
          if (childSubRows?.length) {
            sum += sumMatchingDescendants(childSubRows)
          }
        })

        return sum
      }

      const total = sumMatchingDescendants(subRows)
      return total !== 0 ? total : null
    }

    return null
  }
}

export const createPivotAccessorByGrouping = (pivotValueAccessor, groupingLevel, getSubRows, pivotValue, pivotDisplayName) => {
  return (row) => {
    if (row.__parentChain && Array.isArray(row.__parentChain)) {
      for (const parent of row.__parentChain) {
        if (parent.grouping === groupingLevel) {
          const parentId = parent.orionEntityId || parent.levelName
          const parentName = parent.levelName

          if (parentId === pivotValue || parentName === pivotDisplayName) {
            return get(row, pivotValueAccessor)
          }
          return null
        }
      }
    }

    const dataToSearch = row.__originalData || row
    const sumMatchingDescendants = (rows) => {
      let sum = 0
      if (!Array.isArray(rows)) return sum

      rows.forEach(child => {
        if (child.grouping === groupingLevel) {
          const childId = child.orionEntityId || child.levelName
          const childName = child.levelName

          if (childId === pivotValue || childName === pivotDisplayName) {
            const value = get(child, pivotValueAccessor)
            sum += Number(value)
          }
        }

        const childSubRows = getSubRows(child)
        if (childSubRows?.length) {
          sum += sumMatchingDescendants(childSubRows)
        }
      })

      return sum
    }

    const subRows = getSubRows(dataToSearch)

    if (subRows && subRows.length > 0) {
      const total = sumMatchingDescendants(subRows)
      return total !== 0 ? total : null
    }

    const rowId = dataToSearch.orionEntityId || dataToSearch.levelName
    const rowName = dataToSearch.levelName

    if (dataToSearch.grouping === groupingLevel && (rowId === pivotValue || rowName === pivotDisplayName)) {
      return get(dataToSearch, pivotValueAccessor)
    }

    return null
  }
}
